<a class="nav-link position-relative text-white" [routerLink]="['/page/sport', 'my-matches']" (click)="onClickEvent()">
    <svg class="icon icon--24 icon--white d-block mx-auto mb-1"><use xlink:href="#icon-star" /></svg
    >{{ 'web.my_matches_num' | translate | transinit }}
    <span class="badge badge-primary badge__count">{{ favorite.getNumMatches() }}</span>
</a>
